import styled from 'styled-components'
import { colors, fonts } from 'client/styles'

export const InformationBoxBase = styled.div`
  display: flex;
  flex-direction: column;

  background-color: ${colors.white};
  width: 100%;
  border-radius: 8px;
  border: 2px solid ${colors.grey4};
  border-color: ${props =>
    props.status === 'STATUS_NOT_OK' ? `${colors.red2}` : `${colors.grey4}`};

  font-family: ${fonts.default};
  font-size: 16px;
  line-height: 150%;

  padding-block: 20px;
  padding-inline: 20px;
`

export const Row = styled.div`
  display: flex;
  width: 100%;

  color: ${props => (props.status === 'STATUS_NOT_OK' ? `${colors.red2}` : `${colors.grey2}`)};
`

export const Title = styled(Row)`
  padding-block-end: 12px;
  color: ${props => (props.status === 'STATUS_NOT_OK' ? `${colors.red2}` : `${colors.grey1}`)};
  svg {
    padding-inline-end: 10px;
    fill: ${props => (props.status === 'STATUS_NOT_OK' ? `${colors.red2}` : `${colors.grey1}`)};
  }
`
